import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { makeActionRequestEffect } from 'effects'
import { getAppConfig } from 'app-config'
import join from 'url-join'
import * as fromModuleTypes from './types'
import * as actions from './actions'

export const createEffects = (moduleActions) => {
  const appConfig = getAppConfig()

  const fetchEffect = makeActionRequestEffect({
    type: fromModuleTypes.FETCH,
    url: join(appConfig.app.api, 'exceptions'),
    onSuccess: moduleActions.fetchFulfilled,
    onError: moduleActions.fetchError,
  })

  const acknowledgeEffect = makeActionRequestEffect({
    type: fromModuleTypes.ACKNOWLEDGE_EXCEPTIONS,
    url: join(appConfig.app.api, 'fuel-exceptions/status'),
    verb: 'put',
    onSuccess: actions.requestAcknowledgeExceptionsFulfilled,
    onError: actions.requestAcknowledgeExceptionsError,
  })

  const saveNoteEffect = makeActionRequestEffect({
    type: fromModuleTypes.SAVE_EXCEPTION_NOTE,
    url: join(appConfig.app.api, 'fuel-exceptions/notes'),
    verb: 'post',
    onSuccess: (payload, options) => {
      const followUp = []
      followUp.push(actions.saveExceptionNoteSuccess(payload))
      if (options?.refetchParams) {
        followUp.push(
          actions.getExceptionNotes(null, {
            queryParams: options.refetchParams,
          })
        )
      }
      return followUp
    },
    onError: actions.saveExceptionNoteError,
  })

  // GET notes effect
  const getNotesEffect = makeActionRequestEffect({
    type: fromModuleTypes.GET_EXCEPTION_NOTES,
    url: join(appConfig.app.api, 'fuel-exceptions/notes'),
    verb: 'get',
    onSuccess: (payload) => actions.getExceptionNotesSuccess(payload),
    onError: actions.getExceptionNotesError,
  })

  const getExceptionIssueEffect = makeActionRequestEffect({
    type: fromModuleTypes.GET_EXCEPTION_ISSUE,
    url: join(appConfig.app.api, 'report/exceptionissue'),
    verb: 'get',
    onSuccess: (payload) => actions.getExceptionIssueSuccess(payload),
    onError: actions.getExceptionIssueError,
  })

  const getExceptionHistoryEffect = makeActionRequestEffect({
    type: fromModuleTypes.GET_EXCEPTION_HISTORY,
    url: join(appConfig.app.api, 'fuel-exceptions/history'),
    verb: 'get',
    onSuccess: (payload) => actions.getExceptionHistorySuccess(payload),
    onError: actions.getExceptionHistoryError,
  })

  // UPDATE note effect
  const updateNoteEffect = makeActionRequestEffect({
    type: fromModuleTypes.UPDATE_EXCEPTION_NOTE,
    url: (action) =>
      join(appConfig.app.api, `fuel-exceptions/notes/${action.payload.noteId}`),
    verb: 'put',
    onSuccess: (payload, options) => {
      const followUp = []
      followUp.push(actions.updateExceptionNoteSuccess(payload))
      if (options?.refetchParams) {
        followUp.push(
          actions.getExceptionNotes(null, {
            queryParams: options.refetchParams,
          })
        )
      }
      return followUp
    },
    onError: actions.updateExceptionNoteError,
  })

  // DELETE note effect
  const deleteNoteEffect = makeActionRequestEffect({
    type: fromModuleTypes.DELETE_EXCEPTION_NOTE,
    url: (action) =>
      join(appConfig.app.api, `fuel-exceptions/notes/${action.payload.noteId}`),
    verb: 'delete',
    onSuccess: (payload, options) => {
      const followUp = []
      followUp.push(actions.deleteExceptionNoteSuccess(payload))
      if (options?.refetchParams) {
        followUp.push(
          actions.getExceptionNotes(null, {
            queryParams: options.refetchParams,
          })
        )
      }
      return followUp
    },
    onError: actions.deleteExceptionNoteError,
  })

  const refetchAfterAcknowledgeEffect = (action$) =>
    action$.pipe(
      ofType(fromModuleTypes.ACKNOWLEDGE_EXCEPTIONS_FULFILLED),
      mergeMap(() => of(moduleActions.refetch()))
    )

  return combineEpics(
    fetchEffect,
    acknowledgeEffect,
    saveNoteEffect,
    getNotesEffect,
    getExceptionIssueEffect,
    updateNoteEffect,
    deleteNoteEffect,
    getExceptionHistoryEffect,
    refetchAfterAcknowledgeEffect
  )
}
